import React from 'react';
import HashLoader from "react-spinners/HashLoader";

const Loading = () => {
  return (
    <div className="fixed inset-0 z-50 bg-zinc-600 bg-opacity-95">
      <div className="fixed inset-0"></div>
      <div className="h-full flex justify-center items-center">
        <HashLoader color="#08509A" size={60}/>
      </div>
    </div>
  );
};

export default Loading;
